import React from 'react';

interface ConditionalWrapperProps {
    condition: any;
    wrapper: (children: React.ReactNode) => React.ReactElement
    children: React.ReactElement
}

export const ConditionalWrapper = ({ condition, wrapper, children }: ConditionalWrapperProps): React.ReactElement =>
    condition ? wrapper(children) : children;
